import { useLocation } from "react-router-dom";
import LanguageDropdown from "./languageDropdown.component";
import "./languageSwitcher.component.css";

function GlobalLanguageSwitcher() {
    const location = useLocation();
    // Home hat den Umschalter in der Navbar; Admin ist ausgenommen.
    if (location.pathname === "/" || location.pathname.startsWith("/admin")) return null;

    return (
        <div className="lang-switcher-floating">
            <LanguageDropdown />
        </div>
    );
}

export default GlobalLanguageSwitcher;